/**
 * 카카오톡 채널 URL
 */
export const kakaoTalkUrl = 'https://pf.kakao.com/_LZZLK/chat';

/**
 * 자주 묻는 질문 Notion URL
 */
export const notionFaqUrl = 'https://post.gooduncles.com/febb547b-ec96-4f94-8f7e-947c826fde2f';

export const FIREBASE_AUTH_ERROR_CODE: Record<string, string> = {
  unknown: '알 수 없는 오류가 발생하였습니다.',
  // sign in
  'auth/user-not-found': '존재하지 않는 이메일입니다.',
  'auth/user-disabled': '사용중지된 계정입니다.',
  'auth/wrong-password': '잘못된 비밀번호입니다.',
  'auth/too-many-requests':
    '연속된 실패로 인해 이용이 제한되었습니다.\n잠시 후 다시 시도하시거나 비밀번호 찾기를 이용해 주세요.',
  // sign up
  'auth/email-already-exists': '이미 사용중인 이메일입니다',
  'auth/email-already-in-use': '이미 사용중인 이메일입니다.',
  'auth/invalid-email': '잘못된 이메일 형식입니다.',
  'auth/weak-password': '비밀번호는 6자 이상이어야 합니다.',
};

/**
 * 관리자 개입이 필요한 에러코드
 */
export const FIREBASE_AUTH_ERROR_CODE_FOR_ALERT = ['auth/too-many-requests', 'auth/user-disabled'];

/**
 * Algolia 관련 설정
 * ['state:stock', 'state:out-of-stock']: 판매중지된 상품을 제외한다.
 * hidden:false: 숨김 상품을 제외한다.
 */
export const facetFilters = [['state:stock', 'state:out-of-stock'], ['hidden:false']];
